import { ALGOLIA_INDEX_PREFIX } from '@paperstac/env';
export var getIndexName = function getIndexName(indexName) {
  return "".concat(ALGOLIA_INDEX_PREFIX, "_").concat(indexName);
};